import arrayReduce from 'fast-loops/lib/arrayReduce';

export default function sortObjectKeys(input) {
  var keys = Object.keys(input);
  var sortedKeys = keys.sort(function (a, b) {
    return a.localeCompare(b);
  });

  return arrayReduce(sortedKeys, function (output, key) {
    output[key] = input[key];

    return output;
  }, {});
}